import {
  APPLY_FAVORITES_STATE,
  CLEANUP_PREMATCH_FAVORITES_CONTENT,
} from 'app/modules/PrematchFavorites/actions';
import {
  SET_PREMATCH_FAVORITES_GRID_STAKE_TYPES,
  SET_PREMATCH_FAVORITES_ORDER_KEY,
} from 'app/redux/betting-presentation/grid/actions';
import createGridReducer from 'app/redux/betting-presentation/grid/reducers';

export default createGridReducer({
  APPLY_STATE: APPLY_FAVORITES_STATE,
  RESET_STATE: CLEANUP_PREMATCH_FAVORITES_CONTENT,
  SET_GRID_ORDER_KEY: SET_PREMATCH_FAVORITES_ORDER_KEY,
  SET_GRID_STAKE_TYPES: SET_PREMATCH_FAVORITES_GRID_STAKE_TYPES,
});
